import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Run a scheduled component right away
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestRunScheduledComponent = packet => {
  return {
    type: 'REQUEST_RUN_SCHEDULED_COMPONENT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveRunScheduledComponentSuccess = data => ({
  type: 'RECEIVE_RUN_SCHEDULED_COMPONENT_SUCCESS',
  data
})

export const receiveRunScheduledComponentFail = data => ({
  type: 'RECEIVE_RUN_SCHEDULED_COMPONENT_FAIL',
  data
})

export const tryToRunScheduledComponent = packet => (dispatch, getState) => {

  dispatch(requestRunScheduledComponent(packet));

  let headers = {
    "Content-Type": "application/json"
  }


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }

  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/run-scheduled-component/' + packet.id + '/' + packet.component_id, {
      method: 'post',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveRunScheduledComponentSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveRunScheduledComponentFail({errors:e, lastSubmit: packet}));
    })
}
